export default "__VITE_ASSET__Bqc$U$pa__"